import { supabase } from '../lib/supabase';
export { loadAuditAccounts as loadRecoveryAccounts } from './pinterestAuditService';
export { CREATIVE_ACTIONS, STATUS_LABELS, DIAGNOSIS_LABELS } from '../../supabase/functions/_shared/pinterest-recovery.js';
export async function recoveryRequest(action, context, signal) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Sign in again.');
  const base = import.meta.env.VITE_SUPABASE_FUNCTIONS_URL || `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;
  const response = await fetch(`${base}/pinterest-recovery`, { method: 'POST', signal,
    headers: { Authorization: `Bearer ${session.access_token}`, apikey: import.meta.env.VITE_SUPABASE_ANON_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...context, action }) });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Recovery request failed.');
  return result;
}
export const recoveryRouteState = result => ({ recovery: { ids: result.ids, profileId: result.profileId, accountId: result.accountId, period: result.period } });
